<template>
    <svg :width="fullWidth" :height="height">
        <rect :key="index" :x="0" :y="0" :width="percentWidth" :height="height" fill="#4EAE3B" />
        <text :key="index" :x="percentWidth + 20" :y="height / 2 + 6" text-anchor="middle" fill="#4EAE3B">{{ percent }}%</text>

    </svg>
</template>

<script>
export default {
    props: {
        percent: {
            type: Number,
            required: true,
            default: 50
        },
        fullWidth: {
            type: Number,
            required: true,
            default: 300
        },
        height: {
            type: Number,
            default: 37,
        },
    },
    computed: {
        percentWidth() {
            return (this.fullWidth / 100) * this.percent;
        },
    },
};
</script>